<template>
  <div id="navBarPage">
    <div id="navBar" class="container-fluid secondary-bg">
      <div class="row mx-1">
        <div class="col-12 py-0 d-none d-lg-block ">
          <div class="row">
            <!--            <router-link v-for="item in navItems"
                                     :key="item.id"
                                     :to="item.path"
                                     class="align-self-center px-2 col-auto ">
                          {{ item.text }}
                        </router-link>-->
            <router-link
                class="align-self-center px-2 col-auto "
                to="HomePage">
              خانه
            </router-link>
            <router-link
                class="align-self-center px-2 col-auto "
                to="allProducts">
              محصولات
            </router-link>
            <router-link
                class="align-self-center px-2 col-auto "
                :to="{path:'services', query:{id : 13}}">
              مدارک و تحصیلات
            </router-link>
            <router-link
                class="align-self-center px-2 col-auto "
                :to="{path:'services', query:{id : 14}}">
              نمونه مدارک
            </router-link>
            <router-link
                class="align-self-center px-2 col-auto "
                to="ProductCategories">
              محصولات آموزشی
            </router-link>
            <span class="align-self-center px-2 col-auto">
            <v-menu
                bottom
                class="align-self-center px-2 col-auto"
                offset-y
                open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    dark
                    elevation="0">
                  خدمات
                  <i class="fa-solid fa-angle-down pr-2"></i>
                </v-btn>
              </template>
              <v-list color="secondary">
                <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    class="gray-border-bottom">
                  <v-list-item-title class="white--text font-12 ">
                    <router-link :to="{path:'Services' , query:{id: item.id}}" class="services-btn">
                      {{ item.text }}
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
              </span><!--
            <span class="align-self-center px-2 col-auto">
            <v-menu
                bottom
                class="align-self-center px-2 col-auto"
                offset-y
                open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    dark
                    elevation="0">
                  محصولات
                  <i class="fa-solid fa-angle-down pr-2"></i>
                </v-btn>
              </template>
              <v-list color="secondary">
                <v-list-item
                    class="gray-border-bottom">
                  <v-list-item-title class="white&#45;&#45;text font-12 ">
                    <router-link :to="{path:'allProducts' , query:{type: 1}}" class="services-btn">
                      محصولات فیزیکی
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title class="white&#45;&#45;text font-12 ">
                    <router-link :to="{path:'allProducts' , query:{type: 0}}" class="services-btn">
                      محصولات دیجیتالی
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
              </span>-->

            <div v-if="isLoggedIn" class="col-auto align-self-center text-right">
              <v-menu
                  bottom
                  class="gray-border-bottom"
                  offset-y
                  open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      block
                      color="secondary"
                      dark
                      elevation="0"
                      tile>
                    پروفایل
                    <i class="fa-solid fa-angle-down pr-2"></i>
                  </v-btn>
                </template>
                <v-list color="secondary ">
                  <v-list-item class="gray-border-bottom">
                    <v-list-item-title class="white--text font-12 ">
                      <router-link class="services-btn" to="EditProfile">
                        اطلاعات فردی
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="gray-border-bottom">
                    <v-list-item-title class="white--text font-12 ">
                      <router-link class="services-btn" to="OrdersRecords">
                        سوابق سفارشات
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="gray-border-bottom">
                    <v-list-item-title class="white--text font-12 ">
                      <router-link class="services-btn" :to="{path:'manageAddress', query:{isNew : true}}">
                        تعریف آدرس
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title class="white--text font-12 ">
                      <router-link class="services-btn" :to="{path:'listAddress' , query:{isNew : false}}">
                        لیست آدرس ها
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>

                </v-list>
              </v-menu>
            </div>
            <span v-else class="align-self-center px-2 col-auto  white--text pointer"
                  @click="registerDialog=true">
              ورود/ ثبت نام
            </span>
            <div v-if="isLoggedIn" class="col-auto align-self-center text-right">
              <span class="white--text pointer" @click="showSignOutDialog = true">خروج</span>
            </div>
            <!--            <router-link class="px-3 col-12 left-nav-link white&#45;&#45;text gray-border-bottom" to="EditProfile">-->
            <!--              پروفایل-->
            <!--            </router-link>-->
            <div class="align-self-center pr-2 pl-0 col-auto white--text ">
              <v-badge
                  :content="numberOrders"
                  overlap
                  color="primary"
                  :value="numberOrders"
              >
                <v-btn class="rounded-lg" color="primary" outlined @click="goToCart">
                  سبدخرید <i class="fa-duotone fa-cart-shopping mr-2"></i>
                </v-btn>
              </v-badge>
            </div>
            <div class="col-auto px-2 align-self-center">
              <v-btn class="rounded-lg" color="primary" outlined @click="openSearchDialog">
                جستجو <i class="fa-duotone fa-search mr-2"></i>
              </v-btn>
            </div>
            <router-link class="col-auto mr-auto d-block align-self-center text-left py-0 pl-1 pr-0" to="/">
              <img
                  alt="لوگو"
                  src="../../assets/img/logo.png"
                  style="max-height: 40px"/>
            </router-link>
          </div>
        </div>
        <!--        <div class="col-auto mx-auto">-->
        <!--          <v-text-field outlined></v-text-field>-->
        <!--        </div>-->
        <div class="col-12 d-block d-lg-none">
          <div class="row">
            <div class="col-auto">
            <span
                class="pointer d-block d-lg-none"
                @click.stop="drawer = !drawer">
              <i class="fa-duotone fa-bars  white--text border rounded p-2"></i></span>
            </div>
            <div class="col-auto pl-md-2 px-1">
              <span @click="goToCart">
                 <v-badge
                     :content="numberOrders"
                     overlap
                     color="primary"
                     :value="numberOrders"
                 >
                <i class="fa-duotone fa-cart-shopping border rounded p-2 primary-text"></i>
                 </v-badge>
              </span>
            </div>
            <div class="col-auto px-1">
              <span @click="overlay = true">
                       <i class="fa-duotone fa-search border rounded p-2 primary-text"></i>
              </span>
            </div>
            <!--            <div v-if="isLoggedIn" class="col-auto pr-1">
                          <span>
                            <i class="fa-duotone fa-user border rounded p-2 primary-text"></i>
                          </span>
                        </div>-->
            <div v-if="!isLoggedIn" class="col-auto pr-md-1 px-1">
              <span @click="registerDialog=true">
                <i class="fa-duotone fa-sign-in border rounded p-2 primary-text"></i>
              </span>
            </div>

            <div v-if="isLoggedIn" class="col-auto pr-1 px-1">
              <span @click="showSignOutDialog = true">
                <i class="fa-duotone fa-sign-out border rounded p-2 primary-text"></i>
              </span>
            </div>
            <div class="col-auto mr-auto d-block d-lg-none">
              <img
                  alt="لوگو"
                  src="../../assets/img/logo.png"
                  style="max-height: 40px"/>
            </div>
          </div>
        </div>
      </div>
      <v-navigation-drawer v-if="isLoggedIn" id="drawerItem" v-model="drawer" color="secondary"  :value="value"
                           v-on:input="$emit('input', $event)"
                           fixed
                           temporary
                           right>
        <v-list dense nav>
          <v-list-item-group v-model="group">
            <div class="col mx-auto my-15">
              <img
                  alt="لوگو"
                  class=""
                  src="../../assets/img/logo.png"
                  style="max-height: 40px">
            </div>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="HomePage">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  خانه
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="allProducts">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  محصولات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link :to="{path:'services', query:{id : 13}}">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  مدارک و تحصیلات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link :to="{path:'services', query:{id : 14}}">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  نمونه مدارک
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="ProductCategories">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  محصولات آموزشی
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-group
                no-action class="gray-border-bottom">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="white--text"><i class="fa-solid fa-period pl-3 primary-text"></i>خدمات
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  class="gray-border-bottom"
                  link>
                <v-list-item-title>
                  <router-link :to="{path:'Services' , query:{id: item.id}}">
                    {{ item.text }}
                  </router-link>
                </v-list-item-title>

              </v-list-item>
            </v-list-group>
            <!--
            <v-list-group
                no-action class="gray-border-bottom">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="white&#45;&#45;text"><i class="fa-solid fa-period pl-3 primary-text"></i>محصولات
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                  class="gray-border-bottom">
                <v-list-item-title class="white&#45;&#45;text font-12 ">
                  <router-link :to="{path:'allProducts' , query:{type: 1}}" class="services-btn">
                    محصولات فیزیکی
                  </router-link>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title class="white&#45;&#45;text font-12 ">
                  <router-link :to="{path:'allProducts' , query:{type: 0}}" class="services-btn">
                    محصولات دیجیتالی
                  </router-link>
                </v-list-item-title>
              </v-list-item>
            </v-list-group>-->
            <v-list-group
                no-action class="gray-border-bottom">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="white--text"><i class="fa-solid fa-period pl-3 primary-text"></i>پروفایل
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                  class="gray-border-bottom">
                <v-list-item-title class="white--text font-12 ">
                  <router-link to="EditProfile" class="services-btn">
                    اطلاعات فردی
                  </router-link>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="gray-border-bottom">
                <v-list-item-title class="white--text font-12 ">
                  <router-link to="OrdersRecords" class="services-btn">
                    سوابق سفارشات
                  </router-link>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="gray-border-bottom">
                <v-list-item-title class="white--text font-12 ">
                  <router-link :to="{path:'manageAddress', query:{isNew : true}}" class="services-btn">
                    تعریف آدرس
                  </router-link>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="gray-border-bottom">
                <v-list-item-title class="white--text font-12 ">
                  <router-link :to="{path:'listAddress' , query:{isNew : false}}" class="services-btn">
                    لیست آدرس ها
                  </router-link>
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="AboutUs">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  درباره ما
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="ConnectUs">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  تماس با ما
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="RulesOfRegulation">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  قوانین و مقررات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="CommentsAndComplaints">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  ثبت نظر/ شکایت
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="EventsList">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  رویداد
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="NewsesList">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  اخبار
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="ArticlesList">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  مقالات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <!--            <v-list-group class="gray-border-bottom"
                                      no-action>
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title class="white&#45;&#45;text "><i class="fa-solid fa-period pl-3 primary-text"></i>خدمات
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item
                              v-for="(item, i) in navDrawerDropdown"
                              :key="i"
                              class="gray-border-bottom"
                              link>
                            <v-list-item-title>
                              <router-link :to="item.path">
                                {{ item.text }}
                              </router-link>
                            </v-list-item-title>

                          </v-list-item>
                        </v-list-group>-->
          </v-list-item-group>
        </v-list>
        <!--        <div class="white&#45;&#45;text mr-5"><i class="fa-solid fa-period pl-3 primary-text"></i>خروج</div>-->
      </v-navigation-drawer>

      <v-navigation-drawer v-else id="drawerItem" v-model="drawer" color="secondary" right temporary fixed>
        <v-list dense nav>
          <v-list-item-group>
            <div class="col mx-auto my-15">
              <img
                  alt="لوگو"
                  class=""
                  src="../../assets/img/logo.png"
                  style="max-height: 40px">
            </div>

            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="HomePage">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  خانه
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="allProducts">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  محصولات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link :to="{path:'services', query:{id : 13}}">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  مدارک و تحصیلات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link :to="{path:'services', query:{id : 14}}">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  نمونه مدارک
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="ProductCategories">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  محصولات آموزشی
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-group
                no-action class="gray-border-bottom">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="white--text"><i class="fa-solid fa-period pl-3 primary-text"></i>خدمات
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  class="gray-border-bottom"
                  link>
                <v-list-item-title>
                  <router-link :to="{path:'Services' , query:{id: item.id}}">
                    {{ item.text }}
                  </router-link>
                </v-list-item-title>

              </v-list-item>
            </v-list-group>
<!--            <v-list-group
                no-action class="gray-border-bottom">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="white&#45;&#45;text"><i class="fa-solid fa-period pl-3 primary-text"></i>محصولات
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                  class="gray-border-bottom">
                <v-list-item-title class="white&#45;&#45;text font-12 ">
                  <router-link :to="{path:'allProducts' , query:{type: 1}}" class="services-btn">
                    محصولات فیزیکی
                  </router-link>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title class="white&#45;&#45;text font-12 ">
                  <router-link :to="{path:'allProducts' , query:{type: 0}}" class="services-btn">
                    محصولات دیجیتالی
                  </router-link>
                </v-list-item-title>
              </v-list-item>
            </v-list-group>-->
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="AboutUs">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  درباره ما
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="ConnectUs">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  تماس با ما
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="RulesOfRegulation">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  قوانین و مقررات
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="CommentsAndComplaints">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  ثبت نظر/ شکایت
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="EventsList">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  رویداد
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="NewsesList">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  اخبار
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
                class="gray-border-bottom">
              <v-list-item-title>
                <router-link to="ArticlesList">
                  <i class="fa-solid fa-period pl-3 primary-text"></i>
                  مقالات
                </router-link>
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>

        </v-list>
      </v-navigation-drawer>
      <!--      <v-dialog
                v-model="showLogin"
                hide-overlay
                persistent
                width="500">
              <v-card class="text-center ">
                <v-card-title class="justify-space-between primary-bg">
                  <i class="fa-duotone fa-circle-xmark pointer shadow-lg font-30" @click="showLogin = false"></i>
                  <router-link to="Login">
                    <div class="white&#45;&#45;text"></div>
                  </router-link>
                </v-card-title>
                <v-card-text class="">
                  <div class="mb-0 black&#45;&#45;text "></div>
                  <router-link to="Panel">
                    <v-form ref="form">
                      <div class="row">
                        <div class="col-12">
                          <v-text-field v-model="phone" placeholder="شماره موبایل"
                                        :rules="required"></v-text-field>
                        </div>
                      </div>
                    </v-form>
                    <v-btn
                        @click="showLogin = false"
                        block
                        color="secondary"
                        elevation="0"
                    >
                      دریافت کد فعال سازی
                    </v-btn>
                    <div class="col-12">
                      <v-text-field v-model="code" placeholder="کد فعال سازی"
                      ></v-text-field>
                    </div>
                    <v-btn
                        @click="showLogin = false"
                        block
                        color="third"
                        elevation="0"
                    >
                      ورود به سامانه
                    </v-btn>
                  </router-link>
                </v-card-text>
              </v-card>
            </v-dialog>-->
    </div>
    <v-dialog
        v-model="registerDialog"
        hide-overlay
        width="500">
      <v-card class="third-bg">
        <v-card-title class=" lighten-2 secondary-bg">
          <div class="row justify-content-between">
            <div class="col-auto  font-16 white--text">ورود / ثبت نام</div>
            <div class="col-auto">
              <v-btn
                  color="primary"
                  icon
                  small
                  @click="registerDialog = false"
              >
                <i class="fas fa-times font-16 ml-1"></i>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class=" py-4">
          <v-form ref="form">
            <div class="my-4 text-right">موبایل</div>
            <v-text-field
                v-model="mobile"
                :rules="phoneNumberRules"
                class="mb-1"
                dense
                flat
                placeholder="موبایل"
                solo
                type="number">
            </v-text-field>
            <div class="my-3 text-center">
              <v-btn :disabled=" mobile === null || mobile.length != 11"
                     class="px-10"
                     color="primary"
                     elevation="0"
                     rounded
                     @click="getVerifyCode">
                <span class="white--text"> درخواست کد</span>
              </v-btn>
            </div>
            <div class="my-4 text-right">کد تایید موبایل</div>
            <v-text-field
                v-model="password"
                :rules="[v => !!v || 'کد تایید  اجباری است']"
                class="mb-1"
                dense
                flat
                placeholder="رمزعبور"
                solo>
            </v-text-field>
            <div class="my-3 text-center">
              <v-btn :disabled="password === null || password.length ===0" class="px-16" color="primary" elevation="0"
                     rounded
                     @click="register">
                <span class="white--text">ثبت نام/ورود</span>
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
        <!--            <v-card-actions class='row text-right'>
                      <div class="col-12 px-md-8">
                        رمزعبور خود را فراموش کرده اید؟
                        <span class="pointer text-primary" @click="forgetPasswordDialog =true">
                          بازیابی رمزعبور
                        </span>
                      </div>
                    </v-card-actions>-->
      </v-card>
    </v-dialog>
    <v-overlay
        id="searchOverLay"
        :absolute="absolute"
        :opacity="opacity"
        :value="overlay"
        :z-index="6">
      <div class="text-left">
        <v-btn
            class="m-2"
            color="primary"
            icon
            large
            @click="overlay = !overlay">
          <i class="fa-duotone fa-times font-19"></i>
        </v-btn>
      </div>
      <div id="searchFieldsBox" class="row h-75 align-items-center">
        <div class="col-10 col-md-6 mx-auto pr-0">
          <div class="row ">
            <div class="col-11 ">
              <v-text-field
                  v-model="searchKeyWord"
                  class="mb-1"
                  clearable
                  flat
                  placeholder="جستجو محتوا..."
                  @keydown="searchContent($event)"
              >
              </v-text-field>
            </div>
            <div class="col-1 align-self-center align-items-center">
              <v-btn color="primary" icon @click="searchContentBtn">
                <i class="fas fa-search"></i>
              </v-btn>
            </div>
          </div>
        </div>
      </div>


    </v-overlay>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        z-index="1000000"
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <v-btn
              color="primary"
              icon
              @click="showResultDialog = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showSignOutDialog"
        hide-overlay
        width="500">
      <v-card>
        <v-card-title class="primary-bg py-2">
          <div class="row no-gutters">
            <div class="col text-left">
              <v-btn

                  icon
                  small
                  @click="showSignOutDialog = false"
              >
                <v-icon small color="white">fa-times</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pb-2">
          <div class="text-center black--text mt-5">
            آیا میخواهید از حساب کاربری خود خارج شوید؟
          </div>
          <div class="text-center mt-4">
            <v-btn
                color="primary"
                rounded
                elevation="0"
                @click="signOut"
            >
              بله
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    drawer: false,
    group: null,
    showLoaderDialog: false,
    showResultDialog: false,
    showSignOutDialog: false,
    absolute: false,
    dialogResult: null,
    opacity: 0.90,
    overlay: false,
    showLogin: false,
    isLoggedIn: false,
    numberOrders: 0,
    navDrawerItems: [

      {
        id: 1,
        text: "خانه",
        icon: "",
        path: "/HomePage",
        query: ''
      },
      {
        id: 2,
        text: "مدارک و تحصیلات",
        path: "services",
        query: 13
      },

      {
        id: 3,
        text: "تماس با ما",
        path: "/ConnectUs"
      },
      {
        id: 4,
        text: "درباره ما",
        path: "/AboutUs"
      },
      {
        id: 5,
        text: "قوانین و مقررات",
        path: "/RulesOfRegulation"
      },
      {
        id: 6,
        text: "ثبت نظر/ شکایت",
        icon: "",
        path: "/vvv"
      },
      {
        id: 7,
        text: "دوره های آموزشی",
        icon: "",
        path: "/ii"
      },
      {
        id: 8,
        text: "محصولات آموزشی",
        icon: "",
        path: "/ppp"
      },
      {
        id: 9,
        text: "همایش",
        icon: "",
        path: "/ik"
      },
      {
        id: 10,
        text: "رویداد",
        icon: "",
        path: "/tt"
      },
      {
        id: 11,
        text: "اعضای باشگاه ایران زیلو",
        icon: "",
        path: "/eee"
      },
      {
        id: 12,
        text: "اخبار",
        icon: "",
        path: "/ww"
      },
      {
        id: 13,
        text: "مقالات",
        icon: "",
        path: "/x"
      },


    ],
    navDrawerDropdown: [

      {
        id: 1,
        text: "مشاوره خصوصی",
        path: "/",

      },
      {
        id: 2,
        text: "فرانچایز",
        path: "/Home"
      },
      {
        id: 3,
        text: "برگزاری همایش",
        path: "/ggg"
      },
      {
        id: 4,
        text: "برگزاری ورکشاپ در شهر شما",
        path: "/ggs"
      },

      {
        id: 5,
        text: "دریافت نمایندگی",
        path: "/s"
      },
      {
        id: 6,
        text: "ساخت آژانس املاک",
        path: "/t"
      },
      {
        id: 7,
        text: "صدور مدارک فنی حرفه ای و بین المللی",
        path: "/n"
      },
      {
        id: 8,
        text: "خدمات حقوقی مسکن و املاک",
        path: "/a"
      },
      {
        id: 9,
        text: "هوشمندسازی فایلینگ املاک",
        path: "/t"
      },
      {
        id: 10,
        text: "ساخت و اپلیکیشن املاک",
        path: "/p"
      },
      {
        id: 11,
        text: "ایران زیلو",
        path: "/y"
      },
      {
        id: 12,
        text: "اعضای باشگاه ایران زیلو",
        icon: "",
        path: "/"
      },
    ],
    isShow: false,
    navItems: [
      {
        id: 2,
        text: "خانه",
        path: "/HomePage"

      },
      {
        id: 3,
        text: "مدارک و تحصیلات",
        path: "/Certificates",
        query: ""
      },
      {
        id: 4,
        text: "محصولات آموزشی",
        path: "/ProductCategories"
      },


    ],
    cruds: [
      ['Create', 'mdi-plus-outline'],
      ['Read', 'mdi-file-outline'],
      ['Update', 'mdi-update'],
      ['Delete', 'mdi-delete'],
    ],
    items: [
      {
        id: 1,
        text: "مشاوره خصوصی",
        path: "/"
      },
      {
        id: 2,
        text: "فرانچایز",
        icon: "",
        path: "/"
      },
      {
        id: 3,
        text: "برگزاری همایش",
        icon: "",
        path: "/"
      },
      {
        id: 4,
        text: "برگزاری ورکشاپ در شهر شما",
        icon: "",
        path: "/"
      },

      {
        id: 5,
        text: "دریافت نمایندگی",
        icon: "",
        path: "/"
      },
      {
        id: 6,
        text: "ساخت آژانس املاک",
        icon: "",
        path: "/"
      },
      {
        id: 7,
        text: "صدور مدارک فنی حرفه ای و بین المللی",
        icon: "",
        path: "/"
      },
      {
        id: 8,
        text: "خدمات حقوقی مسکن و املاک",
        icon: "",
        path: "/"
      },
      {
        id: 9,
        text: "هوشمندسازی فایلینگ املاک",
        icon: "",
        path: "/"
      },
      {
        id: 10,
        text: "ساخت و اپلیکیشن املاک",
        icon: "",
        path: "/"
      },
      {
        id: 11,
        text: "ایران زیلو",
        icon: "",
        path: "/"
      },

      {
        id: 12,
        text: "اعضای باشگاه ایران زیلو",
        icon: "",
        path: "/"
      },

    ],
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    registerDialog: false,
    password: null,
    searchKeyWord: null,
    currentBag: [],
    mobile: null,
    pageIndex: 1,
    pageSize: 30,
  }),
  mounted() {
    this.silentLogin()
  },
  methods: {
    getVerifyCode() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/RecoveryOrRequestVerfiyMobile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.showResultDialog = true
            this.dialogResult = result
          })
          .catch(error => console.log('error', error));
    },
    signOut() {
      this.showSignOutDialog = false
      this.isLoggedIn = false
      this.$setUserData('', '', '', '')
      this.silentLogin()
      if (this.$route.path !== "/HomePage")
        this.$router.replace('/HomePage')
    },
    openSearchDialog() {
      this.overlay = true
    },
    silentLogin() {
      let userData = this.$getUserData()
      if (userData.mobile !== '' && userData.activeCode !== '' && userData.mobile !== undefined && userData.activeCode !== null) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userData.mobile);
        urlencoded.append("VerifyCode", userData.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/LoginRegister", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                let token = 'Bearer ' + json.JwtToken
                this.$setUserData(userData.mobile, userData.activeCode, token, json.Role);
                this.isLoggedIn = true;
                if (json.Role === 1 || json.Role === 2 || json.Role === 3) {
                  this.$router.replace({path: '/Dashboard'})
                }
              } else {
                this.isLoggedIn = false
              }
              this.getCurrentBag()
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
      }


    },
    register() {
      let resStatus = null
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PhoneNumber", this.mobile);
      urlencoded.append("VerifyCode", this.password);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/LoginRegister", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus !== 200) {
              this.dialogResult = result
              this.showResultDialog = true
            } else {
              let json = JSON.parse(result)
              this.token = 'Bearer ' + json.JwtToken
              this.$setUserData(this.mobile, this.password, this.token, json.Role);
              this.registerDialog = false
              this.isLoggedIn = true
              if (json.Role === 1 || json.Role === 2 || json.Role === 3) {
                this.$router.replace({path: '/Dashboard'})
              } else {
                if (this.$route.path !== "/HomePage") {
                  this.$router.push({path: 'HomePage'})
                }
              }

            }

          })
          .catch(error => console.log('error', error));
    },
    goToCart() {
      if (this.isLoggedIn) {
        this.$router.push({path: 'Cart'})
      } else {
        this.showResultDialog = true
        this.dialogResult = 'برای مشاهده سبد خرید ابتدا باید وارد سایت شوید.'
      }
    },
    searchContent(e) {
      if (e.keyCode === 13) {
        this.$router.replace({path: 'searchResult', query: {KeyWord: this.searchKeyWord}})
        this.overlay = false
      }
    },
    searchContentBtn() {
      this.$router.replace({path: 'searchResult', query: {KeyWord: this.searchKeyWord}})
      this.overlay = false
    },
    getCurrentBag() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/CartContents", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.currentBag = JSON.parse(result)
            this.numberOrders = JSON.parse(result).length
          })
          .catch(error => console.log('error', error));
    },
    /*searchContent() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      var url = "/Client/Search?keyWord="

      url += this.searchKeyWord

      if (this.pageIndex !== null) {
        url += "&pageIndex=" + this.pageIndex;
      }
      if (this.pageSize !== null) {
        url += "&pageSize=" + this.pageSize;
      }

      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            if (json.results.TypeSearchResult === "1") {
              this.$router.push({path: 'searchResult', query: {Type: 1}})
            }
            else if (json.results.TypeSearchResult === "2"){
              this.$router.push({path: 'searchResult', query: {Type: 2}})
            }
            else if (json.results.TypeSearchResult === "3"){
              this.$router.push({path: 'searchResult', query: {Type: 3}})
            }
            else if (json.results.TypeSearchResult === "4"){
              this.$router.push({path: 'searchResult', query: {Type: 4}})
            }

            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }*/
  },
};
</script>

<style scoped>

</style>
